// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"354":"68c52e9d","408":"844407e5","496":"f50c19d9","627":"4f362d2f"}[chunkId] + ".chunk.js");